import style from './Input.module.css'

function Input({type, text, name, placeholder, handleOnChange, value, isRequired, multiple }) {
    return(
        <div className={style.form_control}>
            {text && <label htmlFor={name}>{text}:</label>}
            <input type={type} name={name} id={name} placeholder={placeholder} onChange={handleOnChange} value={value} required={isRequired} {...(multiple ? {multiple}:'')}/>
        </div>
    )
}

export default Input